import { affiliateBookingStatuses, BOOKING_STATUS } from "./booking.js";
export var WORKFLOW_EVENT_TYPE;
(function (WORKFLOW_EVENT_TYPE) {
    WORKFLOW_EVENT_TYPE["BOOKING_UPDATE"] = "BOOKING_UPDATE";
})(WORKFLOW_EVENT_TYPE || (WORKFLOW_EVENT_TYPE = {}));
export var WORKFLOW_TYPE;
(function (WORKFLOW_TYPE) {
    WORKFLOW_TYPE["INVOICING"] = "INVOICING";
})(WORKFLOW_TYPE || (WORKFLOW_TYPE = {}));
export var WORKFLOW_SCOPE;
(function (WORKFLOW_SCOPE) {
    WORKFLOW_SCOPE["GLOBAL"] = "GLOBAL";
    WORKFLOW_SCOPE["COMPANY_SPECIFIC"] = "COMPANY_SPECIFIC";
})(WORKFLOW_SCOPE || (WORKFLOW_SCOPE = {}));
export var COMPANY_WORKFLOW_ASSIGNMENT_TYPE;
(function (COMPANY_WORKFLOW_ASSIGNMENT_TYPE) {
    COMPANY_WORKFLOW_ASSIGNMENT_TYPE["INCLUSION"] = "INCLUSION";
    COMPANY_WORKFLOW_ASSIGNMENT_TYPE["EXCLUSION"] = "EXCLUSION";
})(COMPANY_WORKFLOW_ASSIGNMENT_TYPE || (COMPANY_WORKFLOW_ASSIGNMENT_TYPE = {}));
export var ACTION_NODE_SEND_TO;
(function (ACTION_NODE_SEND_TO) {
    ACTION_NODE_SEND_TO["RESPONDENT"] = "RESPONDENT";
    ACTION_NODE_SEND_TO["COMPANY_CONTACT"] = "COMPANY_CONTACT";
})(ACTION_NODE_SEND_TO || (ACTION_NODE_SEND_TO = {}));
export var TRIGGER_NODE_TYPE;
(function (TRIGGER_NODE_TYPE) {
    TRIGGER_NODE_TYPE["SIMPLE"] = "SIMPLE";
    TRIGGER_NODE_TYPE["ADVANCED"] = "ADVANCED";
    TRIGGER_NODE_TYPE["SCHEDULED"] = "SCHEDULED";
})(TRIGGER_NODE_TYPE || (TRIGGER_NODE_TYPE = {}));
export var WORKFLOW_TRIGGER;
(function (WORKFLOW_TRIGGER) {
    // simple
    WORKFLOW_TRIGGER["BOOKING_COMPLETION"] = "BOOKING_COMPLETION";
    WORKFLOW_TRIGGER["SURVEY_COMPLETION"] = "SURVEY_COMPLETION";
    WORKFLOW_TRIGGER["BOOKING_CANCELLATION"] = "BOOKING_CANCELLATION";
    // advanced
    WORKFLOW_TRIGGER["BOOKING_UPDATE"] = "BOOKING_UPDATE";
    WORKFLOW_TRIGGER["RESPONDENT_UPDATE"] = "RESPONDENT_UPDATE";
})(WORKFLOW_TRIGGER || (WORKFLOW_TRIGGER = {}));
export var WORKFLOW_NODE_TYPE;
(function (WORKFLOW_NODE_TYPE) {
    // Trigger - On Demand
    WORKFLOW_NODE_TYPE["TRIGGER_BOOKING_COMPLETION"] = "TRIGGER_BOOKING_COMPLETION";
    WORKFLOW_NODE_TYPE["TRIGGER_SURVEY_COMPLETION"] = "TRIGGER_SURVEY_COMPLETION";
    WORKFLOW_NODE_TYPE["TRIGGER_BOOKING_CANCELLATION"] = "TRIGGER_BOOKING_CANCELLATION";
    WORKFLOW_NODE_TYPE["TRIGGER_BOOKING_UPDATE"] = "TRIGGER_BOOKING_UPDATE";
    WORKFLOW_NODE_TYPE["TRIGGER_RESPONDENT_UPDATE"] = "TRIGGER_RESPONDENT_UPDATE";
    // Trigger - Scheduled
    WORKFLOW_NODE_TYPE["TRIGGER_SCHEDULED"] = "TRIGGER_SCHEDULED";
    // Actions
})(WORKFLOW_NODE_TYPE || (WORKFLOW_NODE_TYPE = {}));
export var WORKFLOW_RUN_STATUS;
(function (WORKFLOW_RUN_STATUS) {
    WORKFLOW_RUN_STATUS["PENDING"] = "PENDING";
    WORKFLOW_RUN_STATUS["RUNNING"] = "RUNNING";
    WORKFLOW_RUN_STATUS["SUCCESS"] = "SUCCESS";
    WORKFLOW_RUN_STATUS["FAILED"] = "FAILED";
})(WORKFLOW_RUN_STATUS || (WORKFLOW_RUN_STATUS = {}));
export var WORKFLOW_LOG_EVENT;
(function (WORKFLOW_LOG_EVENT) {
    WORKFLOW_LOG_EVENT["CREATE_RUN_ENTRY"] = "CREATE_RUN_ENTRY";
    WORKFLOW_LOG_EVENT["UPDATE_RUN_ENTRY"] = "UPDATE_RUN_ENTRY";
    WORKFLOW_LOG_EVENT["CREATE_RUN_LOG_ENTRY"] = "CREATE_RUN_LOG_ENTRY";
})(WORKFLOW_LOG_EVENT || (WORKFLOW_LOG_EVENT = {}));
export var WORKFLOW_RUN_LOG_SEVERITY;
(function (WORKFLOW_RUN_LOG_SEVERITY) {
    WORKFLOW_RUN_LOG_SEVERITY["INFO"] = "INFO";
    WORKFLOW_RUN_LOG_SEVERITY["WARNING"] = "WARNING";
    WORKFLOW_RUN_LOG_SEVERITY["ERROR"] = "ERROR";
})(WORKFLOW_RUN_LOG_SEVERITY || (WORKFLOW_RUN_LOG_SEVERITY = {}));
export const WORKFLOW_COMPLETED_BOOKING_STATUSES = [
    BOOKING_STATUS.AUTO_COMPLETED,
    BOOKING_STATUS.COMPLETED,
    affiliateBookingStatuses.Confirmed.value,
];
export const CANCELLATION_STATUS = {
    CANCELED: BOOKING_STATUS.CANCELED,
    DID_NOT_ATTEND: BOOKING_STATUS.DID_NOT_ATTEND,
    AFFILIATE_CANCELED: affiliateBookingStatuses.Canceled.value,
    AFFILIATE_DID_NOT_ATTEND: affiliateBookingStatuses.DidNotAttend.value,
};
//# sourceMappingURL=workflow.js.map